import React from "react";
import { node, string } from "prop-types";
import classNames from "classnames";

const GridTableFooter = ({ children, className, ...props }) => (
    <div className={classNames("grid-table-footer", className)} {...props}>
        {children}
    </div>
);

GridTableFooter.propTypes = {
    children: node.isRequired,
    className: string,
};

GridTableFooter.defaultProps = {
    className: "",
};

export default GridTableFooter;
